import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function OfferBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 left-0 right-0 z-50 w-full text-white" style={{
    backgroundColor: '#FF4444'
  }} data-id="element-271">
      <div className="container mx-auto px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center" data-id="element-272">
        <div className="flex items-center gap-2 font-bold text-sm md:text-base" data-id="element-273">
          <span className="text-lg" data-id="element-274">⏳</span>
          <span className="uppercase tracking-wide" data-id="element-275">
            Oferta especial: 50% OFF ·
          </span>
        </div>
        <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm px-3 py-1 rounded-full border border-white/20" data-id="element-276">
          <Clock className="w-4 h-4" data-id="element-277" />
          <span className="font-mono font-bold text-sm md:text-base tabular-nums" data-id="element-278">
            {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:
            {pad(timeLeft.seconds)}
          </span>
        </div>
      </div>
    </div>;
}